import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import analytics from "./posthog";

const PostHogPageviewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    analytics.capture("$pageview", { $current_url: window.location.href });
  }, [location]);

  return null;
};

export default PostHogPageviewTracker;
